// extracted by mini-css-extract-plugin
module.exports = {"ApplyDetails":"index-module_ApplyDetails_39c4t"};